export enum NewsletterConsentMode {
  Notification = 'notification',
  OnboardingNoPurchase = 'onboarding-no-purchase',
  OnboardingPurchase = 'onboarding-purchase',
}

